export const ALL_FUNDS_TAB_KEYS: Record<number, string> = {
  0: 'overview',
  1: 'prices',
  2: 'navs',
  3: 'performance',
};
export const TAB_TITLE_KEYS: Record<number, string> = {
  0: 'fundsFundCentreTabsAllFunds',
  1: 'fundsFundCentreTabsFundsInFocus',
  2: 'fundsFundCentreTabsMyFunds',
};
export const ALL_FUNDS_TAB_TITLE_KEYS: Record<number, string> = {
  0: 'fundCentreOverview',
  1: 'fundCentrePrices',
  2: 'fundCentreNavs',
  3: 'fundCentrePerformance',
};
